export default {
  type: "text",
  style: "",

  data: {
    paddingLeft: 10,
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    html: "I'm a new Text block ready for your content.",
  },
  children: [],
};
